import React, { useState, useRef, useEffect } from "react";

const ScrollToTopButton = () => {
  // 📌 초기 위치를 우측 하단으로 설정
  const [position, setPosition] = useState({ x: window.innerWidth - 60, y: window.innerHeight - 80 });
  const buttonRef = useRef(null);
  const dragRef = useRef({ x: 0, y: 0 });
  const animationRef = useRef(null);
  const isDragging = useRef(false);

  useEffect(() => {
    const handleResize = () => {
      setPosition((prev) => ({
        x: Math.min(prev.x, window.innerWidth - 60), // 📌 창 크기가 줄어들면 자동 조정
        y: Math.min(prev.y, window.innerHeight - 80),
      }));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const updatePosition = (newX, newY) => {
    if (animationRef.current) cancelAnimationFrame(animationRef.current);
    animationRef.current = requestAnimationFrame(() => {
      setPosition({ x: newX, y: newY });
    });
  };

  const onMouseDown = (event) => {
    event.preventDefault();
    isDragging.current = false;
    dragRef.current = {
      x: event.clientX - position.x,
      y: event.clientY - position.y,
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const onMouseMove = (event) => {
    if (Math.abs(event.clientX - position.x) > 5 || Math.abs(event.clientY - position.y) > 5) {
      isDragging.current = true;
    }
    updatePosition(event.clientX - dragRef.current.x, event.clientY - dragRef.current.y);
  };

  const onMouseUp = () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  };

  const onTouchStart = (event) => {
    const touch = event.touches[0];
    isDragging.current = false;
    dragRef.current = {
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    };
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("touchend", onTouchEnd);
  };

  const onTouchMove = (event) => {
    event.preventDefault();
    const touch = event.touches[0];

    if (Math.abs(touch.clientX - position.x) > 5 || Math.abs(touch.clientY - position.y) > 5) {
      isDragging.current = true;
    }
    updatePosition(touch.clientX - dragRef.current.x, touch.clientY - dragRef.current.y);
  };

  const onTouchEnd = () => {
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", onTouchEnd);
  };

  const scrollToTop = (event) => {
    if (!isDragging.current) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      ref={buttonRef}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onClick={scrollToTop}
      aria-label="맨 위로 스크롤"
      style={{
        position: "fixed",
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: "40px",
        height: "40px",
        backgroundColor: "rgba(100, 100, 255, 0.8)",
        color: "white",
        borderRadius: "50%",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "grab",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.15)",
        fontSize: "18px",
        userSelect: "none",
        touchAction: "none",
        transition: "background-color 0.2s ease",
      }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19V7" />
        <path d="M5 12l7-5 7 5" />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;
